<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  fullWidth?: boolean
  class?: string
}

const props = defineProps<Props>()

const classes = computed(() => ({
  'app-container': true,
  'app-container--full-width': props.fullWidth,
  [`${props.class}`]: !!props.class,
}))
</script>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-container {
  width: 100%;
  max-width: 80rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0.75rem;
  padding-right: 0.75rem;

  @include media-breakpoint-up(md) {
    max-width: 83rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.app-container--full-width {
  max-width: 100%;
}
</style>
